var exports = {
  "wx": "InboxMessageHeader.module__header___RjNzTT",
  "LD": "InboxMessageHeader.module__headerLeft___RjNzTT",
  "$s": "InboxMessageHeader.module__headerActions___RjNzTT",
  "FW": "InboxMessageHeader.module__headerIconButton___RjNzTT",
  "nr": "InboxMessageHeader.module__headerIcon___RjNzTT",
};

module.exports = exports;
